

import('./mfe/AppBootstrap')
  .then(async ({ renderApp }) => {
    await renderApp();
  })
  .catch();

export {};

